import { MapPin, Mail, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { LASERCUT } from "@/constants/testIds";

export const Contact = () => {
  const waNumber = process.env.REACT_APP_WA_NUMBER;
  const waDisplay = process.env.REACT_APP_WA_DISPLAY;

  return (
    <section id="kontak" className="relative bg-iron py-24 md:py-36 px-6 md:px-12 lg:px-24">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-1">
          <span className="text-xs uppercase tracking-[0.25em] text-brass">Kontak</span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl tracking-tight text-chromed mt-4">
            Mari diskusikan karya Anda.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-8"
        >
          <div className="border-t border-linecol pt-6">
            <MapPin className="text-brass mb-4" size={22} />
            <p className="text-xs uppercase tracking-[0.15em] text-chromed/50 mb-2">Bengkel</p>
            <p data-testid={LASERCUT.contactAddress} className="text-chromed/80 leading-relaxed">
              Jl. Industri Raya No. 45,<br /> Tangerang, Banten 15810
            </p>
          </div>

          <div className="border-t border-linecol pt-6">
            <MessageCircle className="text-brass mb-4" size={22} />
            <p className="text-xs uppercase tracking-[0.15em] text-chromed/50 mb-2">WhatsApp</p>
            <a
              data-testid={LASERCUT.contactWhatsapp}
              href={`https://wa.me/${waNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-chromed/80 hover:text-brass transition-colors"
            >
              {waDisplay}
            </a>
          </div>

          <div className="border-t border-linecol pt-6">
            <Mail className="text-brass mb-4" size={22} />
            <p className="text-xs uppercase tracking-[0.15em] text-chromed/50 mb-2">Email</p>
            <a
              data-testid={LASERCUT.contactEmail}
              href="mailto:halo@lasercut.id"
              className="text-chromed/80 hover:text-brass transition-colors"
            >
              halo@lasercut.id
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
